import script from "./ApplicationInfoPEL.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationInfoPEL.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationInfoPEL.vue?vue&type=style&index=0&id=6f8d16ad&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8d16ad"]])

export default __exports__